<template>
    <div>
        <!-- 顶部 -->
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item
                        v-if="user.user.roles[0].id == 1"
                        :to="{ path: '/home' }"
                    >
                        {{$t('home')}}
                    </el-breadcrumb-item>

                    <el-breadcrumb-item>
                        {{$t('yqddgl')}}
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <!-- 内容 -->
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <!-- 顶部搜索 -->
                    <div class="search">
                        <el-form inline @submit.native.prevent>
                            <el-form-item v-if="this.user.user.roles[0].id == 1" :label="$t('bookName')">
                                <el-select size="small" v-model="searchform.accountId" style="width:180px;" :placeholder="$t('pleaseZhangqi')"  >
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="(item,index) in accountlist" :label="item.bookName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('phone')">
                                <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" style="width: 130px;"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('expireTime')"> 
                                <el-date-picker v-model="value1" 
                                type="datetimerange" size="small" 
                                range-separator="至" 
                                value-format="yyyy-MM-dd HH:mm:ss" 
                                start-placeholder="开始时间" 
                                end-placeholder="结束时间"> 
                                </el-date-picker> 
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click="onSubmit"
                                >
                                    {{$t('query')}}
                                </el-button>
                            </el-form-item>

                            <el-form-item>
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click="distributor"
                                >
                                    {{$t('fp')}}
                                </el-button>
                            </el-form-item>

                            <el-form-item>
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click="download"
                                >
                                    下载
                                </el-button>
                            </el-form-item>

                        </el-form>
                    </div>

                    <!-- 表格 -->
                    <el-table
                        :data="list"
                        @selection-change="handleSelectionChange"
                        border
                        style="width: 100%"
                        :header-cell-style="{
                            background:'#f5f5f5',
                            fontWeight:'bold',
                            color:'#555',
                            padding:'6px 0'
                        }"
                    >

                        <!-- 多选 -->
                        <el-table-column
                            type="selection"
                            width="55"
                        />

                        <!-- 商户订单号 -->
                        <el-table-column
                            prop="mchOrderNo"
                            :label="$t('mchOrderNo')"
                            min-width="180"
                        >
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('mchOrderNo')}}</span>
                                    <el-input
                                        v-model="searchform.mchOrderNo"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>

                        <!-- 催收员 -->
                        <el-table-column
                            prop="callName"
                            :label="$t('csy')"
                            min-width="150"
                        >
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('csy')}}</span>

                                    <el-select
                                        v-model="searchform.principalId"
                                        size="mini"
                                        clearable
                                        filterable
                                        @change="onSubmit"
                                    >   
                                        <el-option
                                            v-for="item in principallist"
                                            :key="item.id"
                                            :label="item.nickName || item.username"
                                            :value="item.id"
                                        />
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>

                        <!-- 类型 -->
                        <el-table-column
                            prop="settleNum"
                            :label="$t('status')"
                            width="140"
                        >
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('status')}}</span>

                                    <el-select
                                        v-model="searchform.statusValue"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option
                                            :label="$t('loan4')"
                                            :value="0"
                                        />

                                        <el-option
                                            :label="$t('loan5')"
                                            :value="1"
                                        />
                                    </el-select>
                                </div>
                            </template>

                            <template slot-scope="scope">
                                <el-tag
                                    v-if="scope.row.settleNum == 0"
                                    type="info"
                                >
                                    {{$t('loan4')}}
                                </el-tag>

                                <el-tag
                                    v-else
                                    type="success"
                                >
                                    {{$t('loan5')}}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="body" :label="$t('pingt')">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('pingt')}}</span>
                                    <el-input
                                        v-model="searchform.platform"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="overdueDay" :label="$t('overdueDay')">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('overdueDay')}}</span>
                                    <el-input-number
                                        v-model="searchform.overdueDay"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="expireTime" :label="$t('expireTime')" />
                        <el-table-column prop="loanTime" :label="$t('ckrq')" />
                        <el-table-column prop="days" :label="$t('days')" />
                        <el-table-column prop="cantidad" :label="$t('cantidad')" />
                    </el-table>

                    <!-- 分页 -->
                    <div class="page">
                        <app-page
                            :total="total"
                            :current="pageNo"
                            :pageSize="pageSize"
                            @handleCurrentChange="currentchange"
                            @handleSizeChange="handchange"
                        />
                    </div>

                </div>
            </div>
        </div>

        <!-- 分配弹窗 -->
        <pop-up
            :title="$t('fp')"
            :isshow="showadd"
            :haveconfirm="true"
            @close="getclose"
            @confirm="getconfirm"
        >
            <div slot="box">
                <el-form
                    ref="form"
                    :model="form"
                    size="small"
                    label-width="100px"
                >
                    <el-form-item
                        :label="$t('csy')"
                        required
                    >
                        <el-select
                            v-model="form.principalId"
                            filterable
                            clearable
                            style="width:300px"
                        >
                            <el-option
                                v-for="item in principallist"
                                :key="item.id"
                                :label="item.username"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>

    </div>
</template>

<script>
import fileDownload from "js-file-download";
import apiurl from "@/api/public"
import _api from "@/api/index"

export default {

    data() {
        return {
            loading: false,
            user: {},
            list: [],
            total: 0,
            pageNo: 1,
            pageSize: 10,
            showadd: false,
            principallist: [],
            multipleSelection: [],
            selectData: null,
            searchTimer: null,
            value1:[],
            searchform: {
                phone: '',
                mchOrderNo: '',
                principalId: null,
                statusValue: null
            },
            form: {
                principalId: null
            }

        }
    },

    mounted() {
        this.user=JSON.parse(localStorage.getItem("userinfo"))
        const name = this.user.user.username
        var date = new Date();
        var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
        const timeArr = UTCTime - 6 * 60 * 60 * 1000;
        const timeStr = this.formatTime(timeArr)
        this.addWatermark(`${name} ${timeStr}`)
    },

    created() {
        this.user = JSON.parse(localStorage.getItem("userinfo"))
        this.getList()
        this.getprincipal()
        this.getaccount()
    },

    methods: {
        // 水印
        addWatermark(text) {
            const canvas = document.createElement('canvas')
            canvas.width = 300
            canvas.height = 200
            const ctx = canvas.getContext('2d')
            ctx.rotate(-20 * Math.PI / 180)
            ctx.font = '16px Arial'
            ctx.fillStyle = 'rgba(0,0,0,0.08)'
            ctx.fillText(text, 20, 100)
            const base64 = canvas.toDataURL()
            const div = document.createElement('div')
            div.style.position = 'fixed'
            div.style.top = '0'
            div.style.left = '0'
            div.style.width = '100%'
            div.style.height = '100%'
            div.style.pointerEvents = 'none'
            div.style.backgroundImage = `url(${base64})`
            div.style.zIndex = '9999'
            document.body.appendChild(div)
        },
        formatTime(timestamp) {
            const d = new Date(timestamp)
            const pad = (n) => n.toString().padStart(2, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        },
        // 防抖搜索
        debounceSearch() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.onSubmit()
            }, 500)
        },
        getaccount() {
            _api.get(apiurl.accountBook, {
                nation:localStorage.getItem("nation"),
            }).then(res => {
                this.accountlist = res.data
            })
        },

        // 获取列表
        getList() {
            this.loading = true
            _api.get(apiurl.overdueorder, {
                page: this.pageNo,
                size: this.pageSize,
                phone: this.searchform.phone,
                mchOrderNo: this.searchform.mchOrderNo,
                principalId: this.searchform.principalId,
                type: this.searchform.statusValue,
                createTime: this.value1,
                accountId:this.searchform.accountId,
                nation: localStorage.getItem("nation"),
                platform: this.searchform.platform,
                overdueDay: this.searchform.overdueDay,
            }).then(res => {
                this.loading = false
                this.list = res.data.list || []
                this.total = res.data.total || 0
            }).catch(() => {
                this.loading = false
            })
        },

        download() {
            _api.download(apiurl.download, {
                page: this.pageNo,
                size: this.pageSize,
                phone: this.searchform.phone,
                createTime: this.value1,
                mchOrderNo: this.searchform.mchOrderNo,
                principalId: this.searchform.principalId,
                type: this.searchform.statusValue,
                accountId:this.searchform.accountId,
                nation: localStorage.getItem("nation"),
                platform: this.searchform.platform,
                overdueDay: this.searchform.overdueDay,
            }).then(res => {
                let a = document.createElement('a');
                let blob = new Blob([res], {type: "application/vnd.ms-excel"});
                let objectUrl = URL.createObjectURL(blob);
                a.setAttribute("href", objectUrl);
                a.setAttribute("download", '逾期订单数据.xls');
                a.click();
            })
        },

        // 获取催收员
        getprincipal() {
            _api.get(apiurl.users, {
                roleId: 3,
                nation: localStorage.getItem("nation")
            }).then(res => {
                this.principallist = res.content || []
            })
        },

        // 查询
        onSubmit() {
            this.pageNo = 1
            this.getList()
        },

        // 分页size
        handchange(size) {
            this.pageSize = size
            this.pageNo = 1
            this.getList()
        },

        // 分页
        currentchange(page) {
            this.pageNo = page
            this.getList()
        },

        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val
            this.selectData = val.map(item => item.id).join(",")
        },

        // 打开分配
        distributor() {
            if (!this.selectData) {
                this.$message.error(this.$t('qgxfpdd'))
                return
            }
            this.showadd = true
            this.form = {
                principalId: null
            }
        },

        // 关闭
        getclose() {
            this.showadd = false
        },

        // 确认分配
        getconfirm() {
            if (!this.form.principalId) {
                this.$message.error(this.$t('qxzcsymc'))
                return
            }
            _api.post(apiurl.distributor, {
                selectData: this.selectData,
                principalId: this.form.principalId,
                nation: localStorage.getItem("nation")
            }).then(() => {
                this.$notify.success({
                    title: this.$t('success'),
                    message: this.$t('addSuccess')
                })
                this.showadd = false
                this.getList()
            }).catch(err => {
                this.$notify.error({
                    title: this.$t('error'),
                    message: err.data.message
                })
            })
        }
    }
}
</script>

<style scoped>

.listbox {
    display: flex;
}

.listright {
    width: 100%;
}

.search {
    margin-bottom: 10px;
}

.table-filter {
    display: flex;
    flex-direction: column;
    padding: 4px;
}

.table-filter span {
    margin-bottom: 4px;
    font-size: 13px;
}

.page {
    margin-top: 15px;
    text-align: right;
}

</style>